<div class="one-morning" *ngIf="employer">
	<section class="hero">
		<h2>Better mornings for {{ employer.employerName }} start <em>here</em>.</h2>
	</section>
	<section class="well-being">
		<div class="copy fade-in">
			<div class="pre-headline">A New Morning for Employee Wellness</div>
			<div class="headline">Your well-being matters.</div>
			<div class="text">When the “good” in “good morning” feels hollow. When persevering seems impossible. When your to-do list is miles long, and getting help is yet another time-consuming task. One Morning has your back. Because life’s a struggle, but finding help shouldn’t be.</div>
		</div>
	</section>
	<section class="video">
		<video poster="/assets/images/home-video-poster.png" controls [interact]="{ engagementTypeID: 1, resource: 'Home Page Hero Video' }">
			<source [src]="env.homeVideoURL" type="video/mp4" />
		</video>
	</section>
	<section class="new-light" *ngIf="content[3] as data">
		<div class="col fade-in">
			<div class="headline">Get support anytime.</div>
			<p class="text">Get the support you and your family need from your EAP &ndash; at zero cost.</p>
			<p class="text">Our mental health is with us wherever we are. Why pretend it doesn't affect us? By facing it head-on, we can embrace the possiblity of better.</p>
			<p class="text">Talk it out. Type it out. Text it out. Connect with a counselor in the way that works for you. Confidential support is available 24/7 for you and your entire household &ndash; ready whenever you need it.</p>
			<p class="text url-code">
				<a class="cta" [href]="data['URL']" target="_blank" [interact]="{ engagementTypeID: 4, resource: 'Visit Your EAP - Home' }">Visit Your EAP</a>
				<span *ngIf="data['Group Code']"><b>Enter group code:</b>&nbsp;{{ data["Group Code"] }}</span>
			</p>
		</div>
		<div class="col fade-in">
			<ul class="access">
				<li *ngIf="data['Free Visits']">
					<span>{{ data["Free Visits"] }}</span>
					<span>Free one-on-one counseling sessions per person per year.</span>
				</li>
				<li *ngIf="data['Access'] && data['Toll Free Number']">
					<span>{{ data["Access"] }}</span>
					<span
						>Live, toll-free phone access to licensed, experienced counselors by calling <i class="nowrap">{{ data["Toll Free Number"] | phone }}</i></span
					>
				</li>
				<li *ngIf="data['Text Phone Number']">
					<span><img src="/assets/images/mobile-phone.svg" /></span>
					<span>Text a mental health coach for emotional support. Message "Hi" to {{ data["Text Phone Number"] | phone }}</span>
				</li>
				<li *ngIf="data['Custom Content']">
					<span><img src="/assets/images/information.svg" /></span>
					<span [innerHTML]="data['Custom Content']"></span>
				</li>
			</ul>
		</div>
	</section>

	<app-app-download *ngIf="content[4] as data" [data]="data"></app-app-download>

	<section class="learn-more fade-in">
		<div class="copy">
			<div class="headline">When you need help getting help.</div>
			<div class="text">Whatever life throws at us &ndash; anxiety, loss, hardship &ndash; help is much closer than we think. No matter your circumstances, there is free, confidential support through your Employee Assistance Program. Don&rsquo;t wait until it&rsquo;s too hard to ask for help.</div>
			<div class="actions" *ngIf="content[3] as data"><a class="cta" [href]="data['URL']" target="_blank" [interact]="{ engagementTypeID: 4, resource: 'Visit Your EAP - Home' }">Visit Your EAP</a></div>
		</div>
		<div class="img"></div>
	</section>

	<app-crisis-cards-section *ngIf="content[2]" [data]="content[2]"></app-crisis-cards-section>

	<div class="sunrise">
		<section class="quote fade-in">
			<ng-container *ngIf="content[1] as data">
				<div class="quote-container">
					<p class="quote-content">“{{ data["Quote"] }}”</p>
					<p class="attribution">— {{ data["Quote Source"] }}</p>
				</div>
			</ng-container>
		</section>
		<section class="video-cards fade-in" *ngIf="videoCards?.length">
			<div class="copy">
				<div class="headline">Watch Real Stories</div>
				<div class="text">When people decide it's time to make a change, hope happens.</div>
			</div>
			<div class="video-card-holder">
				<p-carousel *ngIf="showCarousel" [value]="videoCards" [numVisible]="PAGE_SIZE" [circular]="false" [showIndicators]="true" [showNavigators]="false" (onPage)="onPageChange($event)" [ngClass]="{ 'first-page': carouselIndex <= 0, 'last-page': carouselIndex == videoCards.length - PAGE_SIZE || videoCards.length <= PAGE_SIZE }">
					<ng-template let-card pTemplate="item">
						<app-video-card [cardData]="card" (onPlay)="playVideo($event)"></app-video-card>
					</ng-template>
					<ng-template pTemplate="previousicon"> </ng-template>
					<ng-template pTemplate="nexticon"> </ng-template>
				</p-carousel>
			</div>
		</section>
	</div>

	<section class="outro">
		<p class="fade-in">It gets <i>easier</i>, starting now.</p>
	</section>
</div>

<div class="video-player" *ngIf="activeVideo">
	<div class="video-content">
		<div class="close" (click)="closeVideo()"><span class="material-symbols-outlined">close</span></div>
		<h1 *ngIf="activeVideo.title">
			{{ activeVideo.title }}<span class="tag" *ngIf="activeVideo.tag">{{ activeVideo.tag }}</span>
		</h1>
		<iframe *ngIf="isVimeo(activeVideo.videoFile)" [src]="activeVideo.videoFile | safe : 'resourceUrl'" width="100%" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen> </iframe>
		<video *ngIf="!isVimeo(activeVideo.videoFile)" controls autoplay [interact]="{ engagementTypeID: 1, resource: activeVideo.title }">
			<source [src]="activeVideo.videoFile" type="video/mp4" />
		</video>
		<p *ngIf="activeVideo.cardContent">{{ activeVideo.cardContent }}</p>
	</div>
</div>
